/** User-facing PDF load/upload error messages (shared by session, pdf.js, viewer). */
export function parsePdfUserError(err: unknown): string {
  const msg = err instanceof Error ? err.message : String(err);
  const lower = msg.toLowerCase();
  // FX-C6 Fix 5: narrowed 'invalid' match to PDF-specific phrases only.
  // The old broad lower.includes('invalid') classified any server validation error
  // (e.g. "invalid fontFamily") as a corrupted-PDF message. Now only match
  // phrases that actually indicate a bad PDF file structure.
  if (
    lower.includes('does not appear to be a valid pdf') ||
    lower.includes('invalid pdf') ||
    lower.includes('invalid pdf structure') ||
    lower.includes('not a valid pdf')
  ) {
    return 'Could not read this PDF. The file may be corrupted or not a valid PDF.';
  }
  if (lower.includes('corrupt or password-protected')) {
    return 'Could not read this PDF. The file may be corrupted, password-protected, or not a valid PDF.';
  }
  if (lower.includes('corrupt')) {
    return 'Could not read this PDF. The file may be corrupted or not a valid PDF.';
  }
  if (lower.includes('password') || lower.includes('encrypted')) {
    return 'This PDF is password-protected. Remove the password (Print to PDF or Save As) and upload again.';
  }
  return msg || 'Failed to load PDF. Try re-uploading or use a different file.';
}